import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StandardOverview.module.css';
import { OverviewTextAction } from './OverviewCardShell';

const KnowledgeRow = ({ title, summary, onOpen }) => (
    <div className={styles.knowledgeRow}>
        <div>
            <p className={styles.deliveryRowTitle}>{title}</p>
            <p className={styles.deliveryRowMeta}>{summary}</p>
        </div>
        <OverviewTextAction onClick={onOpen}>Open →</OverviewTextAction>
    </div>
);

const ProjectKnowledgeCard = ({ model }) => {
    const navigate = useNavigate();
    const { knowledge, features } = model;

    if (!features?.projectKnowledge) {
        return null;
    }

    if (!features.lessonsLearnt && !features.journal) {
        return null;
    }

    return (
        <section className={styles.knowledgeCard}>
            <p className={styles.cardEyebrow}>Project Knowledge</p>
            {features.lessonsLearnt ? (
                <KnowledgeRow
                    title="Lessons Learnt"
                    summary={
                        knowledge.lessonsSummary ||
                        (knowledge.lessonsCount > 0 ? `${knowledge.lessonsCount} entries` : 'No entries yet')
                    }
                    onOpen={() => navigate('/lessons')}
                />
            ) : null}
            {features.journal ? (
                <KnowledgeRow
                    title="Journal"
                    summary={
                        knowledge.journalSummary ||
                        (knowledge.journalEntryCount > 0 ? `${knowledge.journalEntryCount} entries` : 'No entries yet')
                    }
                    onOpen={() => navigate('/journal')}
                />
            ) : null}
        </section>
    );
};

export default ProjectKnowledgeCard;
